import React from 'react';

const ValueProps = () => {
  const props = [
    {
      number: '01',
      icon: 'speed',
      title: 'Efficiency',
      description: 'Streamlined scheduling and AI-optimized routing ensure your team never misses a beat or a meeting.',
      stat: 'AI Route Optimization',
      statIcon: 'auto_awesome',
      accent: 'teal'
    },
    {
      number: '02',
      icon: 'verified_user',
      title: 'Reliability',
      description: 'Our 99.8% on-time performance record defines our commitment to your corporate punctuality.',
      stat: '99.8% On-Time Rate',
      statIcon: 'timer',
      fill: true,
      accent: 'red'
    },
    {
      number: '03',
      icon: 'security',
      title: 'Safety',
      description: 'Rigorous background checks and multi-point vehicle inspections for absolute peace of mind.',
      stat: '100% Driver Verified',
      statIcon: 'shield',
      accent: 'teal'
    }
  ];

  return (
    <section className="py-[40px] bg-surface">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        <div className="grid md:grid-cols-3 gap-[24px]">
          {props.map((prop, index) => (
            <div
              key={index}
              className="relative bg-surface-container-lowest rounded-[16px] p-[32px] border border-outline-variant/20 overflow-hidden group hover:shadow-xl transition-all duration-500"
            >
              {/* Top accent bar */}
              <div className={`absolute top-[0px] left-[0px] right-[0px] h-[4px] ${prop.accent === 'teal' ? 'bg-primary' : 'bg-secondary'}`} />

              {/* Faded background number */}
              <div className="absolute -top-[12px] -right-[4px] text-[110px] font-extrabold text-on-surface/[0.035] font-headline leading-none select-none pointer-events-none">
                {prop.number}
              </div>

              <div className="relative z-10">
                {/* Icon badge */}
                <div className={`w-[48px] h-[48px] rounded-[12px] flex items-center justify-center mb-[20px] ${prop.accent === 'teal' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'}`}>
                  <span
                    className="material-symbols-outlined text-[24px]"
                    style={prop.fill ? { fontVariationSettings: "'FILL' 1" } : {}}
                  >
                    {prop.icon}
                  </span>
                </div>

                <h3 className="font-headline text-[24px] font-bold mb-[12px]">{prop.title}</h3>
                <p className="text-on-surface-variant leading-relaxed text-[14px] mb-[24px]">{prop.description}</p>

                {/* Stat chip */}
                <div className={`inline-flex items-center gap-[6px] px-[12px] py-[6px] rounded-full text-[12px] font-semibold ${prop.accent === 'teal' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'}`}>
                  <span className="material-symbols-outlined text-[14px]">{prop.statIcon}</span>
                  {prop.stat}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;


